import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json"
import ProjectSession from "../../project-session"
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : true,
    canCreateProject        : true,
    canCreateLink           : true,
    canCreateEmbed          : true,
    canCreateMeeting        : true,
    canCreateEvent          : true,
    canCreateDiscussion     : true,
    canCreateDocument       : true,
    canCreateGoal           : true,
    canCreateDashboard      : true,
    canCreateRequestForms   : true,
    canCreateAttachments    : true,
    canArchive              : true
}

export default class ProjectSupportSystemProperties extends ProjectProperties {

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask                      = DEFAULT.canCreateTask
        this.canCreateProject                   = DEFAULT.canCreateProject
        this.canCreateLink                      = DEFAULT.canCreateLink
        this.canCreateEmbed                     = DEFAULT.canCreateEmbed
        this.canCreateMeeting                   = DEFAULT.canCreateMeeting
        this.canCreateEvent                     = DEFAULT.canCreateEvent
        this.canCreateDiscussion                = DEFAULT.canCreateDiscussion
        this.canCreateDocument                  = DEFAULT.canCreateDocument
        this.canCreateGoal                      = DEFAULT.canCreateGoal
        this.canCreateDashboard                 = DEFAULT.canCreateDashboard
        this.canCreateRequestForms              = DEFAULT.canCreateRequestForms
        this.canCreateAttachments               = DEFAULT.canCreateAttachments
        this.canArchive                         = DEFAULT.canArchive
        this.canHaveStatus                      = true
        this.canHaveViews                       = true

        this.menuSections.customers             = false
        this.menuSections.reports               = false

        this.settingsSections.emailTemplates    = true
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : false,
            info            : true,
            users           : true,
            settings        : true,

            history         : true,
            rename          : true,
            editSource      : false,
            colorIcon       : true,

            move            : true,
            convert         : false,
            duplicate       : false,
            saveAsTemplate  : false,

            status          : true,
            archive         : true,

            delete          : true,

            directLink      : true,
            showInMenu      : true
        }
    }

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
